import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'sb-pool-list',
  templateUrl: './sb-pool-list.component.html',
  styleUrls: ['./sb-pool-list.component.scss'],
  standalone: false,
})
export class SbPoolListComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
